<template>
    <el-container class="full">
        <!-- 侧边 -->
        <el-aside class="print-hide" width="200px">
            <side-bar>
                <div slot="trademark" class="title-box"><span>管理后台</span></div>
                <div slot="router"><component :is="item.children && item.children.length ? 'sub-menu' : 'menu-item'" v-for="item in menuList" :key="item.name" :data="item" /></div>
            </side-bar>
        </el-aside>
        <el-container class="full-height bg-gray">
            <!-- 头部 -->
            <el-header class="no-padding index-header print-hide" style="height:73px;z-index:1000;"><top-bar /></el-header>
            <!-- 主体 -->
            <div id="page-container" class="main">
                <transition name="fade-transform" mode="out-in">
                    <keep-alive :include="keepAliveComponents"><router-view :key="$route.path" class="content" /></keep-alive>
                </transition>
            </div>
        </el-container>
    </el-container>
</template>
<script>
/* eslint-disable space-infix-ops */

import TopBar from '../components/TopBar';
import SideBar from '../components/side-bar';
import MenuItem from '../components/side-bar/menu-item';
import SubMenu from '../components/side-bar/sub-menu';
import { pms2MenuList, decrypt } from '../filters/filter';
import { mapState } from 'vuex';
import { getRoleDetail } from '@/api/auth';
import Utils from '@/jslibs/utils';
import { encrypt } from '@/filters/filter';
import { mapMutations } from 'vuex';

export default {
    name: 'Index',
    components: {
        TopBar,
        SideBar,
        MenuItem,
        SubMenu
    },
    data() {
        return {
            menuList: [
                // {
                //     iconClass: "el-icon-lock",
                //     name: "权限管理",
                //     route: "/role-manage",
                //     children: [
                //         { name: "管理员列表", route: "/admin-list" },
                //         { name: "身份管理", route: "/role-list" },
                //         { name: "菜单管理", route: "/menu-list" }
                //     ]
                // }
                // {
                //   iconClass: 'el-icon-folder',
                //   name: '内容管理',
                //   route: '/content-manage',
                //   children: [
                //     { name: '轮播图管理', route: '/scroll-list' },
                //     { name: '首页主图管理', route: '/ad-list' },
                //     { name: '注册协议', route: '/content-agreement' },
                //     { name: '关于我们', route: '/content-about' },
                //     { name: '联系方式管理', route: '/content-address' }
                //   ]
                // },
                // {
                //   iconClass: 'el-icon-folder',
                //   name: '用户管理',
                //   route: '/user-manage',
                //   children: [
                //     { name: '用户列表', route: '/user-list' },
                //     { name: '用户单位', route: '/unit-list' }
                //   ]
                // },
                // {
                //   iconClass: 'el-icon-folder',
                //   name: '产品管理',
                //   route: '/product-manage',
                //   children: [
                //     { name: '产品列表', route: '/product-list' },
                //     { name: '产品系列', route: '/series-list' }
                //   ]
                // }
            ],
            newOrders: [],
            dialogVisible: false,
            noChildMunuList: ['积分设置', '消息推送', '数据统计']
        };
    },

    computed: {
        ...mapState(['permissionList', 'keepAliveComponents'])
    },

    watch: {},
    async created() {
        if (this.permissionList instanceof Array && !this.permissionList.length) {
            return this.$router.replace('/login');
        }
        this.menuList = pms2MenuList(JSON.parse(decrypt(this.permissionList)));

        const id = Utils.getCookie('X-Access-Group');
        if (id) {
            var {
                group: { rule_tree }
            } = await getRoleDetail(id);

            const permissionList = [];
            const operationList = [];
            rule_tree.forEach(one => {
                const children = [];
                // 只有一级时
                if (this.noChildMunuList.includes(one.menu_name)) {
                    if (one.son_rule) {
                        const three = one.son_rule;
                        operationList.push({
                            name: one.menu_name,
                            operations: three.map(i => i.menu_name)
                        });
                    }
                }
                if (one.son_rule) {
                    one.son_rule.forEach(two => {
                        if (!this.noChildMunuList.includes(one.menu_name)) {
                            children.push({
                                name: two.menu_name,
                                menu_url: two.menu_url
                            });
                        }
                        // 把三级权限数据赋给oprationlist
                        // 在二级页面根据oprationlist 匹配三级权限
                        let three = [];
                        if (two.son_rule) {
                            // 如果菜单有二级
                            three = two.son_rule.map(item => {
                                return item.menu_name;
                            });
                        }
                        if (!this.noChildMunuList.includes(one.menu_name)) {
                            operationList.push({
                                name: two.menu_name,
                                operations: three
                            });
                        }
                    });
                }

                permissionList.push({
                    name: one.menu_name,
                    children
                });
            });
            this.menuList = pms2MenuList(permissionList);
            const jsonStrPer = JSON.stringify(permissionList);
            const encryptPer = encrypt(jsonStrPer).toString();
            sessionStorage.setItem('permission', encryptPer);
            this.update_permission_list(encryptPer);
            this.update_operation_list(operationList);
        }
    },

    mounted() {},
    methods: {
        ...mapMutations(['update_operation_list', 'update_permission_list', 'updateLoginData'])
    }
};
</script>

<style lang="less">
.index-header {
    position: absolute;
    // background: rgba(7, 19, 62, 1);
    z-index: 5;
}
.el-header {
    padding-left: 0;
}
.pagination-container {
    text-align: center;
}
.el-pagination {
    display: inline-block;
}

.el-drawer__header span:focus,
.el-drawer.drawer:focus,
.el-drawer__close-btn {
    outline: none;
}
.el-image-viewer__close .el-icon-circle-close {
    color: #fff;
}
</style>
<style lang="less" scoped>
.title-box {
    font-size: 18px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 200px;
    height: 63px;
    img {
        width: 100%;
        height: 100%;
    }
}
.full-height {
    height: 100vh;
    overflow: hidden;
    overflow-y: auto;
}
.main {
    width: 100%;
    height: 100%;
    overflow-y: auto;
}
.main .content {
    padding: 20px 50px 40px 50px;
    margin-top: 73px;
}
.news-item {
    display: flex;
    align-items: center;
    padding: 22px 30px;
    border-bottom: 1px solid #ccc;
    .icon {
        width: 52px;
        height: 52px;
    }
    .middle {
        text-align: left;
        width: 300px;
    }
    .sub-content {
        display: flex;
        justify-content: space-between;
        margin-top: 10px;
    }
    .btn {
        width: 88px;
        height: 40px;
        margin-left: auto;
        background: rgba(255, 192, 50, 1);
        border: none;
    }
}

/deep/.index-dialog {
    /deep/.el-dialog__header {
        padding: 0 !important;
    }
    /deep/.el-dialog__body {
        padding-left: 0;
        padding-right: 0;
    }
    .dialog-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        height: 98px;
        box-sizing: border-box;
        padding: 12px 30px;
        background: rgba(255, 192, 50, 1);
        .slogan {
            font-size: 22px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 30px;
        }
        .title {
            font-size: 28px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(255, 255, 255, 1);
            line-height: 40px;
        }
        .allBtn {
            background: rgba(255, 155, 13, 1);
            width: 120px;
            height: 40px;
            color: rgba(255, 255, 255, 1);
            border: none;
        }
    }
}

/* fade */
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.28s;
}

.fade-enter,
.fade-leave-active {
    opacity: 0;
}

/* fade-transform */
.fade-transform-leave-active,
.fade-transform-enter-active {
    transition: all 0.5s;
}

.fade-transform-enter {
    opacity: 0;
    transform: translateX(-30px);
}

.fade-transform-leave-to {
    opacity: 0;
    transform: translateX(30px);
}
@media print {
    .print-hide {
        display: none;
    }
    .main .content {
        padding: 0;
        margin-top: 0;
        font-size: 14px;
    }
}
</style>
